import { CompanyItem } from 'types';
import type { DocumentContact } from '@mercator-gcp/types/backend/DocumentContact';

export enum SummaryStatus {
  NEW = 'New',
  COMPLETED = 'Completed',
  ON_HOLD = 'On Hold',
  IN_PROGRESS = 'In Progress',
}

type ExtendedProjectActivity = {
  date: string;
  project_name?: string;
  description: string;
  document_type: string;
  document_type_code: string;
  document_url: string;
  document_uuid: string;
  document_id: string;
  permitnum: string;
  status: string;
  companies: CompanyItem[];
  project_id: string;
  related_contacts: DocumentContact[] | string;
};

export type ActivitySummary = {
  count: number;
  date: string;
  summary_status: SummaryStatus;
  latest_activity: ExtendedProjectActivity;
  oldest_activity: ExtendedProjectActivity;
};

export type ProjectActivitySummary = {
  start_date: string;
  end_date: string;
  number_of_completed_activities: number;
  number_of_total_activities: number;
  summarized_activities: ActivitySummary[];
};
